import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutGrid, 
  ClipboardList, 
  Tag, 
  Users, 
  HelpCircle,
  Mail,
  FileText,
  Clock,
  Settings
} from 'lucide-react';

interface SidebarItemProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  active: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ to, icon, label, active }) => {
  return (
    <Link
      to={to}
      className={`flex items-center px-4 py-3 text-sm font-medium rounded-md ${
        active
          ? 'text-green-600 bg-gray-100'
          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
      }`}
    >
      <div className="mr-3 h-6 w-6 text-gray-500">{icon}</div>
      {label}
    </Link>
  );
};

export function AdminSidebar() {
  const location = useLocation();
  
  const isActive = (path: string) => location.pathname === path;
  
  const menuItems = [
    { 
      path: '/admin', 
      label: 'Översikt', 
      icon: <LayoutGrid className="h-6 w-6" /> 
    },
    { 
      path: '/admin/orders', 
      label: 'Beställningar', 
      icon: <ClipboardList className="h-6 w-6" /> 
    },
    { 
      path: '/admin/categories', 
      label: 'Kategorier', 
      icon: <Tag className="h-6 w-6" /> 
    },
    { 
      path: '/admin/producers', 
      label: 'Producenter', 
      icon: <Users className="h-6 w-6 text-green-600" /> 
    },
    { 
      path: '/admin/faqs', 
      label: 'Vanliga frågor', 
      icon: <HelpCircle className="h-6 w-6" /> 
    },
    { 
      path: '/admin/email-templates', 
      label: 'E-postmallar', 
      icon: <Mail className="h-6 w-6" /> 
    },
    { 
      path: '/admin/instructions', 
      label: 'Instruktioner', 
      icon: <FileText className="h-6 w-6" /> 
    },
    { 
      path: '/admin/delivery-times', 
      label: 'Leveranstider', 
      icon: <Clock className="h-6 w-6" /> 
    },
    {
      path: '/admin/settings',
      label: 'Inställningar',
      icon: <Settings className="h-6 w-6" />
    }
  ];

  return (
    <div className="h-screen w-64 bg-white shadow-md">
      <div className="pt-5 pb-4">
        <div className="px-4">
          <h2 className="text-lg font-semibold text-gray-900">Admin Portal</h2>
        </div>
        <nav className="mt-5 px-2 space-y-1">
          {menuItems.map((item) => (
            <SidebarItem
              key={item.path}
              to={item.path}
              icon={item.icon}
              label={item.label}
              active={isActive(item.path)}
            />
          ))}
        </nav>
      </div>
    </div>
  );
} 